import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';

import backend from 'utils/backend';

import SkillResponseView from './SkillResponseView';
import SkillsTextbox from './SkillsTextbox';

const Skills = (props) => {
  const {communicationTarget, requester, resources, statusProgressWrap: progressWrap} = props;

  const requesterRn = requester.userRn;
  const [skillExecutionResponse, setSkillExecutionResponse] = React.useState(null);
  const [lastSkillExecution, setLastSkillExecution] = React.useState(null);
  const [isExecutingSkill, setIsExecutingSkill] = React.useState(false);

  const executeSkill = React.useCallback(async (skill, promptText) => {
    let response = null;

    await progressWrap(async () => {
      try {
        setIsExecutingSkill(true);

        const requestBody = {
          ressources: [
            ...resources,
            {type: 'USER', rn: requesterRn},
          ],
          text: promptText || ' ',
        };

        setLastSkillExecution({
          promptText,
          skill,
        });

        response = await backend.skills.executeSkill(skill.skillRn, requestBody);
        setSkillExecutionResponse(response.result);
      } finally {
        setIsExecutingSkill(false);
      }
    }, {
      showProgress: false,
    });

    return response;
  }, [progressWrap, requesterRn, resources]);

  const handleRegenerate = React.useCallback(() => {
    if (!lastSkillExecution) {
      return null;
    }

    return executeSkill(lastSkillExecution.skill, lastSkillExecution.promptText);
  }, [executeSkill, lastSkillExecution]);

  const handleDiscard = React.useCallback(() => {
    setSkillExecutionResponse(null);
  }, []);

  return (
    <Box>
      {
        skillExecutionResponse &&
        <SkillResponseView
          communicationTarget={communicationTarget}
          requester={requester}
          response={skillExecutionResponse}
          onDiscard={handleDiscard}
          isRegenerating={isExecutingSkill}
          onRegenerate={handleRegenerate}
        />
      }
      <SkillsTextbox
        isExecutingSkill={isExecutingSkill}
        onExecuteSkill={executeSkill}
      />
    </Box>
  );
};

Skills.propTypes = {
  communicationTarget: PropTypes.shape({
    email: PropTypes.string,
    sendEmail: PropTypes.func,
    sendSms: PropTypes.func,
    sms: PropTypes.string,
  }),
  requester: PropTypes.object.isRequired,
  resources: PropTypes.arrayOf(PropTypes.shape({
    rn: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  })).isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  requester: state.user,
});

export default connect(mapStateToProps, dispatch)(React.memo(Skills));
